import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import SelectAsync from "react-select/async";

export default class Contract extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
            data: null,
            loading: true,
            form_version: this.uuidv4(),
            initPerson: this.isNull(props.InitPerson) ? null : props.InitPerson,
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/contract/get", {
            id: this.state.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data = data;
                    if (this.state.id === this.getDefaultGuid()) {
                        if (!this.isNull(this.state.initPerson)) {
                            this.state.data.record.manCompanyId = this.state.initPerson.id;
                            this.state.data.record.manCompanyName = this.state.initPerson.name;
                        }
                    }

                    this.setState({
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        e.preventDefault();
        if (this.isBlank(this.state.data.record.f1)) this.state.data.record.f1 = 0;
        if (this.isBlank(this.state.data.record.f2)) this.state.data.record.f2 = 0;
        if (this.isBlank(this.state.data.record.f3)) this.state.data.record.f3 = 0;
        if (this.isBlank(this.state.data.record.f4)) this.state.data.record.f4 = 0;
        if (this.isBlank(this.state.data.record.f5)) this.state.data.record.f5 = 0;
        if (this.isBlank(this.state.data.record.f6)) this.state.data.record.f6 = 0;
        if (this.isBlank(this.state.data.record.f7)) this.state.data.record.f7 = 0;
        if (this.isBlank(this.state.data.record.f8)) this.state.data.record.f8 = 0;
        if (this.isBlank(this.state.data.record.f9)) this.state.data.record.f9 = 0;
        if (this.isBlank(this.state.data.record.f10)) this.state.data.record.f10 = 0;
        if (this.isBlank(this.state.data.record.f11)) this.state.data.record.f11 = 0;
        if (this.isBlank(this.state.data.record.f12)) this.state.data.record.f12 = 0;
        if (this.isBlank(this.state.data.record.f13)) this.state.data.record.f13 = 0;
        if (this.isBlank(this.state.data.record.f14)) this.state.data.record.f14 = 0;
        if (this.isBlank(this.state.data.record.f15)) this.state.data.record.f15 = 0;
        if (this.isBlank(this.state.data.record.duration)) this.state.data.record.duration = 0;

        this.httpPost("api/v1/contract/save", {
            id: this.state.id,
            companyId: this.state.data.global.company.id,
            name: this.state.data.record.name,
            categoryId: this.state.data.record.categoryId,
            type: this.state.data.record.type,
            startDate: this.state.data.record.startDate,
            finishDate: this.state.data.record.finishDate,
            number: this.state.data.record.number,
            addressAgent: this.state.data.record.addressAgent,
            addressPerson: this.state.data.record.addressPerson,
            manCompanyId: this.state.data.record.manCompanyId,
            orgPostId: this.state.data.record.orgPostId,

            f1: parseInt(this.state.data.record.f1),
            f2: parseInt(this.state.data.record.f2),
            f3: parseInt(this.state.data.record.f3),
            f4: parseInt(this.state.data.record.f4),
            f5: parseInt(this.state.data.record.f5),
            f6: parseInt(this.state.data.record.f6),
            f7: parseInt(this.state.data.record.f7),
            f8: parseInt(this.state.data.record.f8),
            f9: parseInt(this.state.data.record.f9),
            f10: parseInt(this.state.data.record.f10),
            f11: parseInt(this.state.data.record.f11),
            f12: parseInt(this.state.data.record.f12),
            f13: parseInt(this.state.data.record.f13),
            f14: parseInt(this.state.data.record.f14),
            f15: parseInt(this.state.data.record.f15),
            agentName: this.state.data.record.agentName,
            subject: this.state.data.record.subject,
            duration: parseInt(this.state.data.record.duration),
            durationType: this.state.data.record.durationType,
            mode: this.state.data.record.mode,
            baseSalaryMode: this.state.data.record.baseSalaryMode,
            fieldValues: this.state.data.fieldValues
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    if (this.state.refreshCallerAfterSave)
                        this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    getYear() {
        var year = 0;
        try {
            year = parseInt(this.state.data.record.startDate.replace("-", "/").replace("-", "/").split("/")[0]);
        } catch { }
        return year;
    }
    changeSalaryBase(e) {
        this.state.data.record.f1 = 0;
        this.state.data.record.f2 = 0;
        this.state.data.record.f3 = 0;
        this.state.data.record.f4 = 0;
        this.state.data.record.baseSalaryMode = e;
        this.setF1Force();
        this.setF11();
        this.setState({
            data: this.state.data,
            form_version: this.uuidv4()
        });
    }
    setF4(e) {
        this.state.data.record.f4 = parseInt(e);
        this.setF1Force(false);
    }
    setF1Force(referesh = true) {
        var price = 0;
        var lpercent = 0;
        var lprice = 0;

        var sabege = 0;
        try {
            var f8 = this.state.data.record.f8;
            if (this.isBlank(f8)) f8 = 0;
            sabege = parseInt(f8);
        } catch { }

        this.state.data.escalations.forEach(es => {
            if (es.salaryYear == this.getYear() && es.employeeYear == (this.getYear() - sabege)) {
                price = es.price;
            }
        });

        if (this.state.data.record.baseSalaryMode == 1) {
            this.state.data.record.f1 = parseInt(price);
        }
        if (this.state.data.record.baseSalaryMode == 2) {

            this.state.data.salaryBase.forEach(es => {
                if (es.year == this.getYear()) {
                    lpercent = es.otherLevelPercent;
                    lprice = es.otherLevelPrice;
                }
            });
            this.state.data.record.f2 = parseInt(lprice);
            var f4 = this.state.data.record.f4;
            if (this.isBlank(f4)) f4 = 0;
            this.state.data.record.f3 = this.FixedPointNumber((((f4 + price) * lpercent) / 100), 0);

            this.state.data.record.f1 = this.FixedPointNumber((f4 + price + this.state.data.record.f3 + this.state.data.record.f2), 0);
        }
        if (referesh) this.state.form_version = this.uuidv4();
        this.setState({
            data: this.state.data
        });
    }
    setF11() {
        if (this.state.data.record.baseSalaryMode === 3) {
            this.state.data.record.f11 = 0;
            return;
        }
        var sabege = 0;
        try {
            var f8 = this.state.data.record.f8;
            if (this.isBlank(f8)) f8 = 0;
            sabege = parseInt(f8);
        } catch { }
        this.state.data.escalations.forEach(es => {
            if (es.salaryYear == this.getYear() && es.employeeYear == (this.getYear() - sabege))
                this.state.data.record.f11 = es.price;
        });
    }
    setF8(e) {
        this.state.data.record.f8 = parseInt(e);
        this.setF11();
        this.setF1Force(false);
        this.setState({
            data: this.state.data
        });
    }
    setStartDate(e) {
        this.state.data.record.startDate = e;
        this.setF11();
        this.setF1Force();
        this.setState({ data: this.state.data });
    }
    setType(e) {
        this.state.data.record.type = e;
        this.setState({ data: this.state.data });
    }
    setCategory(e) {
        this.state.data.record.categoryId = e;
        this.state.data.fieldValues = [];
        this.state.data.contractCategoryFields.forEach(field => {
            if (field.contractCategoryId === this.state.data.record.categoryId)
                this.state.data.fieldValues.push({ fieldId: field.id, value: '' });
        });
        this.setState({ data: this.state.data });
    }
    setFieldValue(id, v) {
        var newField = true;
        this.state.data.fieldValues.forEach(field => {
            if (field.fieldId === id) {
                field.value = v;
                newField = false;
            }
        });
        if (newField) {
            this.state.data.fieldValues.push({ fieldId: id, value: v });
        }
    }
    getFieldValue(id) {
        var v = '';
        this.state.data.fieldValues.forEach(field => {
            if (field.fieldId === id) v = field.value;
        });
        return v;
    }
    setManCompany(e) {
        this.state.data.record.manCompanyId = e.value;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div
                className="modal-backdrop fade in"
                style={{ height: "100%" }}
                onClick={(e) => this.closeMe()}
            ></div>
            <div className="modal-dialog ui-draggable" style={{ minWidth: "90%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ padding: "0" }}>
                        <div className="modal-header modal-header-info">
                            <button
                                type="button"
                                className="close"
                                onClick={(e) => this.closeMe()}
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 className="modal-title">
                                {this.state.data.record.id != this.defaultGuid()
                                    ? "ویرایش قرارداد"
                                    : "تنظیم قرارداد"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">


                                <div className="row">
                                    {this.state.data.record.id === this.getDefaultGuid() && <div className="col-sm-3">
                                        <div className="form-group">
                                            <label className="title1">نوع قرارداد</label>
                                            <select onChange={e => this.setType(parseInt(e.target.value))} autocomplete="off" type="text" className="form-control input-sm ng-valid">
                                                <option value="0">انتخاب نمایید</option>
                                                <option value="1">قرارداد کارگری و کارفرمایی - بر مبنای اداره کار</option>
                                                <option value="2">قرارداد کار ساعتی</option>
                                                <option value="3">قرارداد های سفارشی</option>
                                            </select>
                                        </div>
                                    </div>}
                                    {this.state.data.record.id === this.getDefaultGuid() && <div className="col-sm-9">
                                        <div className="form-group">
                                            <label className="title1">گروه قرارداد</label>
                                            <select onChange={e => this.setCategory(e.target.value)} autocomplete="off" type="text" className="form-control input-sm ng-valid">
                                                <option value={this.getDefaultGuid()}>انتخاب نمایید</option>
                                                {this.state.data.categories.map(cat =>
                                                    <option value={cat.id}>{cat.title}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>}
                                </div>
                                {this.state.data.record.categoryId !== this.defaultGuid() && <div className="row g-4">
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            شماره قرارداد <input className="form-control" type="text" style={{ "width": "100px", "display": "inline", "marginLeft": "10px" }} defaultValue={this.state.data.record.number} onChange={e => this.state.data.record.number = e.target.value} />
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <h5>طرفین قرارداد</h5>
                                    </div>
                                    <div>طرف اول: {this.state.data.global.company.name} </div>

                                    <div>نماینده طرف اول: <input className="form-control text-center" type="text" defaultValue={this.state.data.record.agentName} onChange={e => this.state.data.record.agentName = e.target.value} />
                                    </div>

                                    <div>نشانی طرف اول: <input className="form-control text-center" type="text" defaultValue={this.state.data.record.addressAgent} onChange={e => this.state.data.record.addressAgent = e.target.value} />
                                    </div>

                                    <div>طرف دوم:
                                        {/*    <select className="form-control text-center" type="text" defaultValue={this.state.data.record.manCompanyId} onChange={e => this.state.data.record.manCompanyId = e.target.value}>*/}
                                        {/*    <option value="0">انتخاب کنید</option>*/}
                                        {/*    {this.state.data.manCompanies.map(p => <option value={p.id}>{p.name}</option>)}*/}
                                        {/*</select>*/}
                                        <SelectAsync
                                            style={{ width: "100%" }}
                                            defaultValue={
                                                this.state.data.record.manCompanyId !=
                                                    this.getDefaultGuid()
                                                    ? [
                                                        {
                                                            value: this.state.data.record.manCompanyId,
                                                            label:
                                                                this.state.data.record.manCompanyName,
                                                        },
                                                    ]
                                                    : null
                                            }
                                            isMulti={false}
                                            placeholder="انتخاب گیرنده نامه"
                                            defaultOptions
                                            loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0, 0)}
                                            onChange={(e) => this.setManCompany(e)}
                                        />

                                    </div>

                                    <div>نشانی طرف دوم: <input className="form-control text-center" type="text" defaultValue={this.state.data.record.addressPerson} onChange={e => this.state.data.record.addressPerson = e.target.value} /></div>

                                    <div className="col-lg-12">
                                        <h5>موضوع قرارداد</h5>
                                    </div>
                                    {(this.state.data.record.type === 2 || this.state.data.record.type === 1) && <p>پست سازمانی : <select className="form-control text-center" style={{ "width": "300px", "display": "inline" }} type="text" defaultValue={this.state.data.record.orgPostId} onChange={e => this.state.data.record.orgPostId = e.target.value}>
                                        <option value="0">انتخاب کنید</option>
                                        {this.state.data.posts.map(p => <option value={p.id}>{p.name}</option>)}
                                    </select></p>}
                                    <p>موضوع قرارداد عبارتست از انجام امور و مسئولیتهای محوله از سوی طرف اول قرارداد برای مدت قرارداد در زمینه <input className="form-control text-center" style={{ "width": "300px", "display": "inline" }} type="text" defaultValue={this.state.data.record.subject} onChange={e => this.state.data.record.subject = e.target.value} /></p>
                                    <div className="col-lg-12">
                                        <h5>مدت قرارداد</h5>
                                    </div>
                                    <p>مدت این قرارداد <input className="form-control text-center" style={{ "width": "100px", "display": "inline" }} type="text" defaultValue={this.state.data.record.duration} onChange={e => this.state.data.record.duration = e.target.value} />
                                        <select className="form-control text-center" style={{ "width": "100px", "display": "inline" }} type="text" defaultValue={this.state.data.record.durationType} onChange={e => this.state.data.record.durationType = parseInt(e.target.value)}>
                                            <option value="1">روز</option>
                                            <option value="2">هفته</option>
                                            <option value="3">ماه</option>
                                            <option value="4">سال</option>
                                        </select> است که از تاریخ <input className="form-control text-center" style={{ "width": "100px", "display": "inline" }} type="text" defaultValue={this.state.data.record.startDate} onChange={e => this.setStartDate(e.target.value)} /> شروع و در تاریخ <input className="form-control text-center" style={{ "width": "100px", "display": "inline" }} type="text" defaultValue={this.state.data.record.finishDate} onChange={e => this.state.data.record.finishDate = e.target.value} /> به پایان می رسد.</p>

                                    <div className="col-lg-12">
                                        <h5>نوع قرارداد</h5>
                                    </div>
                                    {this.state.data.record.type === 1 && <div className="col-lg-12">
                                        <div className="form-group">
                                            نوع قرارداد
                                            <select className="form-control" style={{ "width": "300px", "display": "inline" }} defaultValue={this.state.data.record.mode} onChange={e => this.state.data.record.mode = parseInt(e.target.value)}>
                                                <option value="1">ساعتی - تایم شیت</option>
                                                <option value="2">ثابت ( ماهانه و سالانه ) - تایم شیت</option>
                                                <option value="3">پروژه ای و پیمانی - صورت وضعیت</option>
                                            </select>
                                        </div>
                                    </div>}
                                    {(this.state.data.record.type === 2 || this.state.data.record.type === 1) && <div className="col-lg-12">
                                        <h5>حقوق و مزایا</h5>
                                    </div>}
                                    {this.state.data.record.type === 1 && <div>
                                        <p>حق الزحمه و حقوق عبارت است از : </p>
                                        <p>1-مبنای حقوق بر اساس <select className="form-control text-center" style={{ "width": "200px", "display": "inline" }} type="text" defaultValue={this.state.data.record.baseSalaryMode} onChange={e => this.changeSalaryBase(parseInt(e.target.value))}>
                                            <option value="1">حداقل اداره کار</option>
                                            <option value="3">مزد توافقی ثابت</option>
                                            <option value="2">سایر سطوح</option>
                                        </select></p>
                                        <p>2-سابقه کار تا تاریخ این قرارداد در این شرکت
                                            <input className="form-control text-center" style={{ "width": "100px", "display": "inline" }} type="text" defaultValue={this.state.data.record.f8} onChange={e => this.setF8(e.target.value)} /> سال
                                            <input className="form-control text-center" style={{ "width": "100px", "display": "inline" }} type="text" defaultValue={this.state.data.record.f9} onChange={e => this.state.data.record.f9 = e.target.value} /> ماه
                                            <input className="form-control text-center" style={{ "width": "100px", "display": "inline" }} type="text" defaultValue={this.state.data.record.f10} onChange={e => this.state.data.record.f10 = e.target.value} /> روز
                                        </p>
                                        <div key={this.state.form_version}>
                                            <p>
                                                حق سنوات امسال بر اساس جدول تصاعدی مزد مبلغ <input readOnly={true} className="form-control text-center" style={{ "width": "100px", "display": "inline" }} type="text" key={this.state.data.record.f11} defaultValue={this.state.data.record.f11} /> ریال می باشد
                                            </p>
                                            <p>
                                                پایه سنوات امسال روزانه <input className="form-control text-center" style={{ "width": "100px", "display": "inline" }} type="text" defaultValue={this.state.data.record.f12} onChange={e => this.state.data.record.f12 = e.target.value} /> ریال می باشد
                                            </p>
                                            <p>تبصره یک : سابقه در همین شرکت ملاک عمل بر اساس جدول تصاعدی مزد است</p>
                                            {this.state.data.record.baseSalaryMode !== 3 && <p>3- مزد ثابت (مبنا) روزانه: <input className="form-control text-center" style={{ "width": "200px", "display": "inline" }} type="text" defaultValue={this.state.data.record.f1} key={this.state.data.record.f1} readOnly={true} /></p>}
                                            {this.state.data.record.baseSalaryMode === 3 && <p>3- مزد ثابت (مبنا) توافقی روزانه: <input className="form-control text-center" style={{ "width": "200px", "display": "inline" }} type="text" defaultValue={this.state.data.record.f1} onChange={e => this.state.data.record.f1 = parseInt(e.target.value)} /></p>}
                                            {this.state.data.record.baseSalaryMode == 2 && <p>مبلغ ثابت سایر سطوح روزانه <input className="form-control text-center" style={{ "width": "140px", "display": "inline", "marginLeft": "10px" }} type="text" defaultValue={this.state.data.record.f2} key={this.state.data.record.f2} readOnly={true} />
                                                درصد سایر سطوح روزانه <input className="form-control text-center" style={{ "width": "140px", "display": "inline", "marginLeft": "10px" }} type="text" defaultValue={this.state.data.record.f3} key={this.state.data.record.f3} readOnly={true} />
                                                سایر فوق العاده روزانه <input className="form-control text-center" style={{ "width": "140px", "display": "inline", "marginLeft": "10px" }} type="text" defaultValue={this.state.data.record.f4} onChange={e => this.setF4(e.target.value)} />
                                            </p>}
                                        </div>
                                        <p>4-مزایای ذیل برای طرف دوم لحاظ میگردد : </p>
                                        <p>حق مسئولیت روزانه : <input className="form-control text-center" style={{ "width": "100px", "display": "inline" }} type="text" defaultValue={this.state.data.record.f5} onChange={e => this.state.data.record.f5 = e.target.value} /> ریال </p>
                                        <p>حق جذب روزانه : <input className="form-control text-center" style={{ "width": "100px", "display": "inline" }} type="text" defaultValue={this.state.data.record.f6} onChange={e => this.state.data.record.f6 = e.target.value} /> ریال </p>
                                        <p>سایر فوق العاده های روزانه : <input className="form-control text-center" style={{ "width": "100px", "display": "inline" }} type="text" defaultValue={this.state.data.record.f7} onChange={e => this.state.data.record.f7 = e.target.value} /> ریال </p>
                                        <p>سختی کار روزانه : <input className="form-control text-center" style={{ "width": "100px", "display": "inline" }} type="text" defaultValue={this.state.data.record.f13} onChange={e => this.state.data.record.f13 = e.target.value} /> ریال </p>
                                        <p>فوق العاده شغل روزانه : <input className="form-control text-center" style={{ "width": "100px", "display": "inline" }} type="text" defaultValue={this.state.data.record.f14} onChange={e => this.state.data.record.f14 = e.target.value} /> ریال </p>
                                        <p>فوق العاده کارگاهی روزانه : <input className="form-control text-center" style={{ "width": "100px", "display": "inline" }} type="text" defaultValue={this.state.data.record.f15} onChange={e => this.state.data.record.f15 = e.target.value} /> ریال </p>
                                    </div>}
                                    {this.state.data.record.type === 2 && <div>
                                        <p>دستمزد توافق شده به ازای هر ساعت تایم شیت: <input className="form-control text-center" style={{ "width": "200px", "display": "inline" }} type="text" defaultValue={this.state.data.record.f1} onChange={e => this.state.data.record.f1 = e.target.value} /> ریال</p>
                                    </div>}
                                    <div>
                                        <h5>مفاد</h5>
                                        {this.state.data.contractCategoryFields.map(field =>
                                            field.contractCategoryId === this.state.data.record.categoryId && <div className="col-lg-12">
                                                <div className="form-group">
                                                    {field.title}
                                                    <input className="form-control" type="text" defaultValue={this.getFieldValue(field.id)} onChange={e => this.setFieldValue(field.id, e.target.value)} />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>}

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default btn-smoke" onClick={(e) => this.closeMe()} >
                                انصراف
                            </button>
                            <button type="submit" name="bank_form_modal_submit" className="btn btn-success" onClick={(e) => this.save(e)}>
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect))
            return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading
            ? this.renderLoading()
            : [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
            ];

        return contents;
    }
}
